module.exports = __webpack_public_path__ + "img/microplastics-3-mobile.ac2f59a6.png";